import * as React from 'react';
/**
 * Shared SVG
 *
 * @returns
 */
function SharedSVG(svgProps: SVGProps) {
	return (
		<svg viewBox="0 0 24 24" className={'icon icon-shared ' + svgProps.class} focusable="false" aria-hidden="true">
			<path d="M12 1.6c2.209 0 4 1.791 4 4l-0.006 0.157c2.853 1.455 4.806 4.421 4.806 7.843 0 0.514-0.044 1.019-0.129 1.509 1.044 0.719 1.729 1.925 1.729 3.291 0 2.209-1.791 4-4 4-0.957 0-1.836-0.336-2.525-0.897-1.169 0.575-2.484 0.897-3.875 0.897s-2.707-0.323-3.876-0.897c-0.688 0.561-1.567 0.897-2.524 0.897-2.209 0-4-1.791-4-4 0-1.366 0.685-2.572 1.729-3.293-0.085-0.488-0.129-0.992-0.129-1.507 0-3.422 1.953-6.388 4.806-7.843-0.005-0.051-0.006-0.104-0.006-0.157 0-2.209 1.791-4 4-4zM18.4 16.4c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2s-0.895-2-2-2zM5.6 16.4c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2s-0.895-2-2-2zM14.905 8.349l-0.165 0.165c-0.716 0.673-1.68 1.086-2.74 1.086-1.144 0-2.176-0.48-2.905-1.25-1.846 1.022-3.095 2.99-3.095 5.25 0 0.281 0.019 0.558 0.057 0.828 1.995 0.226 3.543 1.918 3.543 3.972 0 0.23-0.019 0.455-0.056 0.673 0.748 0.339 1.58 0.527 2.456 0.527s1.709-0.188 2.459-0.526c-0.040-0.22-0.059-0.445-0.059-0.674 0-2.054 1.548-3.746 3.541-3.974 0.040-0.269 0.059-0.545 0.059-0.826 0-2.26-1.249-4.228-3.095-5.251zM12 3.6c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2s-0.895-2-2-2z"></path>
		</svg>
	);
}

SharedSVG.defaultProps = { class: '' };

export default SharedSVG;
